module.exports = __webpack_public_path__ + "Roboto-BlackItalic.38d14dd4ff163c34e45b.woff2";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BlackItalic.woff2
// module chunks = 34